<!-- <div class="content-cell">
    <div class="cell-head"><span class="header-text">Bottom Header</span></div>
    <div  class="cell-content tabset-container" kvTabSetBackground>
        <nb-tabset fullWidth>
            <nb-tab tabTitle="Top Header Left">

            </nb-tab>
            <nb-tab tabTitle="Top Header Center">

            </nb-tab>
            <nb-tab tabTitle="Top Header Right">

            </nb-tab>
        </nb-tabset>
    </div>
</div> -->
<nb-tabset fullWidth>
    <nb-tab tabTitle="Top Header Left">

    </nb-tab>
    <nb-tab tabTitle="Top Header Center">

    </nb-tab>
    <nb-tab tabTitle="Top Header Right">

    </nb-tab>
</nb-tabset>
